const { isTouchEvent } = require('./touch');
module.exports = {
  crossDeviceEndEvent: evt => (isTouchEvent(evt) ? evt.changedTouches[0] : evt),
  crossDeviceEvent: evt => (isTouchEvent(evt) ? evt.touches[0] : evt)
};




// WEBPACK FOOTER //
// ./src/common/utils/cross-device-event.js